import React, { useState } from "react"
import ReactPlayer from "react-player"
import { useTransition, animated } from "react-spring"
import styled from "styled-components"

export const StyledVideoModal = styled.div`
  width: 100vw;
  height: 100vh;
  top: 0px;
  left: 0px;
  position: fixed;
  z-index: 99999;
  background: #000;
  padding: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  button {
    color: #fff;
    position: absolute;
    right: 2rem;
    top: 2rem;
  }
  video:focus {
    outline: none;
  }
  > div {
    width: 80%;
  }
  article {
    width: 100%;
    height: 0;
    position: relative;
    padding-top: 56.25%; /* Player ratio: 100 / (1280 / 720) */
  }
  .player {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

const AnimatedVideoModal = animated(StyledVideoModal)

export const VideoModal = ({ video, onClose }) => {
  const [playing, setPlaying] = useState(false)

  const transitions = useTransition(video, null, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  })

  return transitions?.map(
    ({ item, key, props }) =>
      item && (
        <AnimatedVideoModal key={`VideoModal-${key}`} style={props}>
          <button onClick={() => onClose()}>Close</button>
          <div>
            <article>
              {video && (
                <ReactPlayer
                  url={video?.url}
                  playing={playing}
                  playsinline={false}
                  width="100%"
                  height="100%"
                  onReady={() => setPlaying(true)}
                  onEnded={() => onClose()}
                  controls={true}
                  className="player"
                />
              )}
            </article>
          </div>
        </AnimatedVideoModal>
      )
  )
}

export const VideoTeaser = ({ video }) => {
  return (
    <ReactPlayer
      url={video?.url}
      playing={true}
      playsinline={false}
      width="100%"
      height="auto"
      loop={true}
      className="video-teaser"
    />
  )
}
